import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AttachmentType } from './model/attachmentType';

@Component({
    selector: 'app-prereg-application',
    templateUrl: './preRegApplication.component.html',
    styleUrls: ['./application.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PreregApplicationComponent {
    @Input() application: any;
    attachmentType = AttachmentType;
    downloading = false;
    downloadClickCount = 0;

    constructor() {}

}

